app.factory('exerciseService', ['$mdMedia', '$mdDialog', '$mdToast', '$http', '$state', 'mdContentService', function ($mdMedia, $mdDialog, $mdToast, $http, $state, mdContentService) {
	var service = this;

	service.exercises = []
	service.loaded = false;

	service.get = function(id) {
		return $http.get('api/exercise/' + id) // XXX: XSRF
		.then(function (resp) {
		    return resp.data;
		}, function (err) {
		    return null;
		});
	}

	service.load = function() {
		return $http.get('api/exercise').then(function(resp) {
			service.exercises = resp.data.items;
			service.loaded = true;

			// XXX: this is a bit of a hack, but it'll do.
			mdContentService.triggerSyntheticScrollEvent();
		}, function(err) {
			console.log("exerciseService: unable to load exercises");
			service.exercises = []; // errr!
		});
	}

	service.askDelete = function(exercise, ev) {
		ev.preventDefault();

		var confirm = $mdDialog.confirm()
            .title('Slet opgavesæt')
            .textContent('Er du sikker på at du vil fjerne dette opgavesæt?')
            .ariaLabel('Slet opgavesæt')
            .targetEvent(ev)
            .ok('Slet')
            .cancel('Anullér');
        $mdDialog.show(confirm).then(function () {
			return $http.delete('api/exercise/' + exercise.id).then(function(resp) {
				$mdToast.show(
					$mdToast.simple()
						.textContent("Opgavesæt slettet")
						.position('top right')
						.hideDelay(3000));
				$state.reload();
        	}, function () {
        	});
		});
	}

	return service;
}]);